import * as React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  message: string | JSX.Element;
  confirmLabel?: string;
  onClose: () => void;
}
export class AlertDialog extends React.Component<AlertDialogProps> {
  render() {
    const props = this.props;
    return (
      <Modal size="md" isOpen={props.isOpen} toggle={props.onClose} keyboard={true}>
        <ModalHeader toggle={props.onClose}>{props.title}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col" style={{ wordBreak: 'break-word' }}>
              {props.message}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button color="primary" type="submit" onClick={props.onClose}>
              {props.confirmLabel ? props.confirmLabel : 'OK'}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/AlertDialog.tsx